import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {BroadcasterService} from '../core/broadcaster/broadcaster.service';

@Injectable()
export class LatLongEvent {
  constructor(private broadcaster: BroadcasterService) {}

  fire(key: string, lat: Number, lon: Number): void {
    this.broadcaster.broadcast(LatLongEvent, {
      key,
      lat,
      lon
    });
  }

  on(): Observable<any> {
    return this.broadcaster.on<any>(LatLongEvent);
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/events/LatLongEvent.ts